import React from "react";
import "../../styles/pages/impressium/Impressium.scss";
import Footer from "../../components/Footer";

const index = () => {
  return (
    <div className="impressium-page-container">
      <div className="impressum-wrapper">
        <div className="title-container">
          <h1>Impressum</h1>
          <div className="line"></div>
        </div>
        <div className="section-1-container">
          <section className="section-1">
            <h3>Angaben gemäß § 5 </h3>
            <p>Dr. Nawras Darkazanly</p>
            <p>
              Richard-Wagner-Platz 3 <br />
              10585 Berlin
            </p>
          </section>

          <section className="section-1">
            <h3>Kontakt</h3>
            <p>Dr. Nawras Darkazanly</p>
            <p>Telefon: 030 3414060</p>
            <p>E-Mail: info@zahnspange-charlottenburg.de</p>
          </section>

          <section className="section-1">
            <h3>Kammerzugehörigkeit</h3>
            <p>Zahnärztekammer Berlin, Stallstraße 1, 10585 Berlin</p>
            <a
              href="http://www.zaek-berlin.de/"
              target="_blank"
              rel="noreferrer"
            >
              www.zaek-berlin.de
            </a>
          </section>

          <section className="section-1">
            <h3>Berufsbezeichnung und berufsrechtliche Regelungen</h3>
            <h4>Berufsbezeichnung:</h4>
            <p>Dr. Nawras Darkazanly, Fachzahnarzt für Kieferorthopädie</p>
            <p>Verliehen durch: Deutschland</p>
          </section>

          <section className="section-1">
            <h4>Es gelten folgende berufsrechtliche Regelungen:</h4>
            <p>Berufsordnung der Zahnärztekammer Berlin Zahnheilkundegesetz</p>
            <p>Heilberufe-Kammergesetz</p>
            <p>Gebührenordnung für Zahnärzte</p>
            <p>
              Berufsordnung für Zahnärzte und Weiterbildungsordnung der
              Zahnärztekammer Berlin
            </p>
          </section>

          <section className="section-1">
            <p>
              Regelungen einsehbar unter:{" "}
              <a
                href="https://www.zaek-berlin.de/"
                target="_blank"
                rel="noreferrer"
              >
                https://www.zaek-berlin.de/
              </a>
            </p>
          </section>

          <section className="section-1">
            <h3>Zuständige Kassenärztliche Vereinigung</h3>
            <p>
              Kassenzahnärztliche Vereinigung Berlin, Georg-Wilhelm-Straße 16,
              10711 Berlin
            </p>
            <a
              href="http://www.kzv-berlin.de/"
              target="_blank"
              rel="noreferrer"
            >
              www.kzv-berlin.de
            </a>
          </section>

          <section className="section-1">
            <h3>Streitschlichtung</h3>
            <p>
              Die Europäische Kommission stellt eine Plattform zur
              Online-Streitbeilegung (OS) bereit:{" "}
              <a
                href="https://ec.europa.eu/consumers/odr"
                target="_blank"
                rel="noreferrer"
              >
                https://ec.europa.eu/consumers/odr
              </a>
              .<br /> Unsere E-Mail-Adresse finden Sie oben im Impressum.
            </p>
            <p>
              Wir sind nicht bereit oder verpflichtet, an
              Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
              teilzunehmen.
            </p>
          </section>
          <div className="line"></div>

          <section className="section-1">
            <h3>
              web design: &nbsp;
              <a
                title="4selected GmbH"
                href="https://yanal-sabbagh07.github.io/Portfolio/"
                target="_blank"
                rel="noreferrer"
              >
                yanal-sabbagh.com
              </a>
            </h3>
            <div className="yanal-website"></div>
          </section>
          <div className="line"></div>

          <section className="section-1">
            <p>
              <strong>
                Quellenangaben für die verwendeten Bilder und Grafiken:
              </strong>
            </p>
            <span>
              ©&nbsp;
              <a
                title="Das komplette Portfolio von pressmaster ansehen"
                href="https://de.fotolia.com/id/55196285"
              >
                pressmaster
              </a>
            </span>
            &nbsp;/
            <a
              href="https://stock.adobe.com/de"
              target="_blank"
              rel="noreferrer"
            >
              Adobe Stock
            </a>
            <br />
            ©&nbsp;
            <a
              title="Das komplette Portfolio von sonya etchison ansehen"
              href="https://de.fotolia.com/id/5906245"
              target="_blank"
              rel="noreferrer"
            >
              sonya etchison
            </a>
            &nbsp;/{" "}
            <a
              href="https://stock.adobe.com/de"
              target="_blank"
              rel="noreferrer"
            >
              Adobe Stock
            </a>
            <br />
            ©&nbsp;
            <a
              title="Das komplette Portfolio von Tyler Olson ansehen"
              href="https://de.fotolia.com/id/45067956"
            >
              Tyler Olson
            </a>
            &nbsp;/{" "}
            <a
              href="https://stock.adobe.com/de"
              target="_blank"
              rel="noreferrer"
            >
              Adobe Stock
            </a>
          </section>

          <section className="section-1">
            <h3>Haftung für Inhalte</h3>
            <p>
              Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene
              Inhalte auf diesen Seiten nach den allgemeinen Gesetzen
              verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter
              jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde
              Informationen zu überwachen oder nach Umständen zu forschen, die
              auf eine rechtswidrige Tätigkeit hinweisen.
            </p>
            <p>
              Verpflichtungen zur Entfernung oder Sperrung der Nutzung von
              Informationen nach den allgemeinen Gesetzen bleiben hiervon
              unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem
              Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich.
              Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir
              diese Inhalte umgehend entfernen.
            </p>
          </section>

          <section className="section-1">
            <h3>Haftung für Links</h3>
            <p>
              Unser Angebot enthält Links zu externen Websites Dritter, auf
              deren Inhalte wir keinen Einfluss haben. Deshalb können wir für
              diese fremden Inhalte auch keine Gewähr übernehmen. Für die
              Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter
              oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten
              wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße
              überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der
              Verlinkung nicht erkennbar.
            </p>
            <p>
              Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist
              jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht
              zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir
              derartige Links umgehend entfernen.
            </p>
          </section>

          <section className="section-1">
            <h3>Urheberrecht</h3>
            <p>
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf
              diesen Seiten unterliegen dem deutschen Urheberrecht. Die
              Vervielfältigung, Bearbeitung, Verbreitung und jede Art der
              Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der
              schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
              Downloads und Kopien dieser Seite sind nur für den privaten, nicht
              kommerziellen Gebrauch gestattet.
            </p>
            <p>
              Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt
              wurden, werden die Urheberrechte Dritter beachtet. Insbesondere
              werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie
              trotzdem auf eine Urheberrechtsverletzung aufmerksam werden,
              bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von
              Rechtsverletzungen werden wir derartige Inhalte umgehend
              entfernen.
            </p>
          </section>
        </div>
      </div>
      <div className="footer-container">
        <Footer />
      </div>
    </div>
  );
};

export default index;
